import {
  CASE_FETCH_INVITE_LINK_BEGIN,
  CASE_FETCH_INVITE_LINK_SUCCESS,
  CASE_FETCH_INVITE_LINK_FAILURE,
  CASE_FETCH_INVITE_LINK_DISMISS_FEEDBACK,
} from './constants';
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  createPromiseAction,
  resolvePromiseAction,
  rejectPromiseAction,
} from '@adobe/redux-saga-promise';
import api from 'common/api';
import { withCurrentCaseId } from '../../../common/selectors';

export const fetchInviteLink = createPromiseAction(CASE_FETCH_INVITE_LINK_BEGIN);

export function dismissFetchInviteLinkFeedback() {
  return {
    type: CASE_FETCH_INVITE_LINK_DISMISS_FEEDBACK,
  };
}

export function* doFetchInviteLink(action) {
  const { caseId, teamId, user } = action.payload;

  let res = yield call(api.get, `/cases/${caseId}/teams/${teamId}/invites/${user.id}`);

  if (res && res.error) {
    yield put({
      type: CASE_FETCH_INVITE_LINK_FAILURE,
      feedback: {
        message: 'feedback.fetchInviteLinkFailure',
        error: res.error,
        retryAction: action,
      },
    });
    return yield call(rejectPromiseAction, action, res.error);
  }

  yield put({
    type: CASE_FETCH_INVITE_LINK_SUCCESS,
    data: { inviteLink: res },
  });
  yield call(resolvePromiseAction, action, res);
}

export function* watchFetchInviteLink() {
  yield takeLatest(fetchInviteLink, withCurrentCaseId(doFetchInviteLink));
}

export function reducer(state, action) {
  switch (action.type) {
    case CASE_FETCH_INVITE_LINK_BEGIN + '.TRIGGER':
      return {
        ...state,
        fetchInviteLinkPending: true,
        fetchInviteLinkFeedback: null,
      };

    case CASE_FETCH_INVITE_LINK_SUCCESS:
      return {
        ...state,
        fetchInviteLinkPending: false,
        fetchInviteLinkFeedback: action.feedback,
      };

    case CASE_FETCH_INVITE_LINK_FAILURE:
      return {
        ...state,
        fetchInviteLinkPending: false,
        fetchInviteLinkFeedback: action.feedback,
      };

    case CASE_FETCH_INVITE_LINK_DISMISS_FEEDBACK:
      return {
        ...state,
        fetchInviteLinkFeedback: null,
      };

    default:
      return state;
  }
}
